module.exports = __webpack_public_path__ + "images/beb02c0ca49ab2a65ebfa44f0588230d406c698f459d741d205e2ce20cd7dd7e.svg";